<template>
  <div class="custom-modal" id="payment-pos-method">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <el-row v-else key="content-loading">
        <div class="modal-body">
          <div class="tab-payment-contents">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.paymentMethod") }}</label>
                </div>
                <el-select v-model="form.bankId" :disabled="form.posId != null" @change="bankChanged">
                  <el-option v-for="(item, index) in bankList.filter(x => paymentPosId ? true : x.active == true)" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <span class="error">{{ $errorMessage("bankId", validationErrors) }}</span>
              </div>
            </el-col>

            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.currency2") }}</label>
                </div>
                <el-select v-if="getEnums" v-model="form.currency" :disabled="form.posId != null">
                  <el-option v-for="(item, index) in getEnums.find(x => x.title == 'Currency').enums.filter(x => x.key != 0)" :key="index" :label="item.displayName" :value="item.key"></el-option>
                </el-select>
                <span class="error">{{ $errorMessage("currency", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("event.table.title") }}</label>
                </div>
                <el-input type="text" v-model="form.title"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
            <el-col :span="24" v-if="form.bankId != null">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("registrationManagement.registrationForm.description") }}</label>
                </div>
                <el-alert class="payment-description" type="info" v-if="$i18n.locale != 'tr'" :show-icon="true">
                  <span v-html="bankList.find(x => x.id == form.bankId).description"></span>
                </el-alert>
                <el-alert class="payment-description" type="info" v-else :show-icon="true">
                  <span v-html="bankList.find(x => x.id == form.bankId).descriptionTr"></span>
                </el-alert>
                <!-- <span class="error">{{ $errorMessage("title", validationErrors) }}</span> -->
              </div>
            </el-col>
            <template v-if="form.parameters.length > 0 && form.bankId != null">
              <el-col :span="24" v-for="(bankParam, index) in form.parameters" :key="bankParam.id + 'bank-parameters'">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ bankParam.key }}</label>
                  </div>
                  <el-input type="text" :disabled="bankParam.isDefaultParameter" v-model="bankParam.value"></el-input>
                  <span class="error">{{ $errorMessage("parameters[" + index + "].Value", validationErrors) }}</span>
                </div>
              </el-col>
            </template>
          </div>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.close") }}</el-button>
        <template v-if="form.posId != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveMethods'" :disabled="loading == 'saveMethods'" @click="saveMethods">{{ $t("registrationManagement.registrationForm.registerFormDialog.additionalServices.addUpdateRegisterationServices.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["paymentPosId"],
  data() {
    return {
      loading: false,
      tiemout: null,
      form: {
        posId: null,
        bankId: null,
        title: null,
        currency: null,
        parameters: []
      },
      validationErrors: []
    };
  },
  methods: {
    async saveMethods() {
      this.loading = "saveMethods";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateBank", this.form);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.form.posId = res.data.data.posId;
          await this.$store.dispatch("getOrganization");
        }
        this.loading = false;
      }, 500);
    },
    async bankChanged() {
      var res = await this.$store.dispatch("getBankParameters", this.form.bankId);
      this.form.parameters = res.data.data.items;
    },
    deleteItem() {
      this.$emit("closeDialog");
      this.$emit("deleteProviders", this.form.posId);
    }
  },
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      if (this.paymentPosId != null && this.paymentPosId != undefined) {
        var res = await this.$store.dispatch("getPaymentProvider", this.paymentPosId);
        if (res.data.alert.hasError) {
          this.$emit("closeDialog");
        } else {
          this.form = res.data.data.item;
        }
      }
      await this.$store.dispatch("getBanks");
      this.loading = false;
    }, 500);
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    bankList() {
      return this.$store.getters.getBankList;
    }
  }
};
</script>

<style lang="less">
.tab-payment-contents {
  & > .el-col {
    margin-bottom: 1rem;
  }
  .el-input-number {
    width: 100%;
  }
  .registerform-input-container {
    .tag-container {
      gap: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .badge-list {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      .badger {
        border-radius: 8px;
        background-color: #f3f3f3;
        height: 20px;
        padding: 10px;
      }
    }
    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      label {
        font-weight: bold;
        color: black;
        margin-bottom: 0;
      }
      .title-container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
        margin-top: 1rem;
      }
    }
    display: flex;
    flex-direction: column;
    .el-input-number {
      width: 100%;
    }
  }
  .el-upload {
    width: 100%;
    .el-upload-dragger {
      height: 120px;
      .el-icon-upload {
        font-size: 30px;
        margin: 0;
      }
    }
  }
  .packet-head {
    display: grid;
    grid-template-columns: 2fr 1fr 2fr 1fr 1fr;
    border-radius: 5px;
    border: 1px solid #ccc;
    padding: 10px;
    font-weight: bold;
  }
}
.add-update-packet-dialog {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
.add-update-packet-dialog-container {
  .bottom {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
  }
}

.add-pricing-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.input-new-tag {
  width: 100px;
}
.photo-walls {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
  }
  .photo-item {
    position: relative;
    .photo-delete-icon {
      position: absolute;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        color: white;
        font-size: 12px;
      }
      border-radius: 50%;
      background-color: red;
      cursor: pointer;
      right: -0.2rem;
      top: -0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register-form/addOrUpdatePaymentMehods.vue